import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import AddProjectTypeUserDefinedFieldPopup from '../Popups/ProjectType_popup_AddUserDefinedField';

interface Props {
    projectTypeId: number
}

const ProjectType_tab_UserDefinedFields: React.FC<Props> = ({ projectTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [projectTypeId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ProjectTypeUserDefinedFields/ByProjectType/' + projectTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ProjectTypeUserDefinedFields/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'userDefinedFieldId', visible: false },
        { title: 'Name', dataProp: 'userDefinedField.name' },
        { title: 'Data type', dataProp: 'userDefinedField.dataType' },
        { title: 'Type', dataProp: 'userDefinedField.userDefinedFieldType' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.EditProjectType, projectTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtProjectTypeUserDefinedFields'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='User defined field'
                navigateUrl='/plm/ItemSetup/UserDefinedField/'
            />
            {showPopup && <AddProjectTypeUserDefinedFieldPopup projectTypeId={projectTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ProjectType_tab_UserDefinedFields;